module.exports = __webpack_public_path__ + "img/symbol_4.af1d459f.png";